import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import CommonHeader from "./components/CommonHeader";

const HelpFaqManagement = () => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [helpHtml, setHelpHtml] = useState("");
  const [faqHtml, setFaqHtml] = useState("");

  const [initialHelpHtml, setInitialHelpHtml] = useState("");
  const [initialFaqHtml, setInitialFaqHtml] = useState("");

  const [loaded, setLoaded] = useState(false);

  const fetchHelpFaq = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/HelpFaq/getHelpFaqForBooking`,
        {
          method: "post",
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      const resp = await res.json();
      if (resp.status === 1) {
        const nextHelp = resp.help_html || "";
        const nextFaq = resp.faq_html || "";
        setHelpHtml(nextHelp);
        setFaqHtml(nextFaq);
        setInitialHelpHtml(nextHelp);
        setInitialFaqHtml(nextFaq);
        setLoaded(true);
      } else {
        toast.error(resp.message || "Failed to load Help/FAQ");
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to load Help/FAQ");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHelpFaq();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpdate = async () => {
    if (!loaded) return;

    const data = new URLSearchParams();

    const helpChanged = helpHtml !== initialHelpHtml;
    const faqChanged = faqHtml !== initialFaqHtml;

    if (!helpChanged && !faqChanged) {
      toast.error("No changes to update");
      return;
    }

    if (helpChanged) data.append("help_html", helpHtml);
    if (faqChanged) data.append("faq_html", faqHtml);

    if (!data.has("help_html") && !data.has("faq_html")) {
      toast.error("help_html and/or faq_html is required");
      return;
    }

    setSaving(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/HelpFaq/updateHelpFaqContent`,
        {
          method: "post",
          headers: {
            Authorization: localStorage.getItem("token"),
          },
          body: data,
        }
      );

      const resp = await res.json();
      if (resp.status === 1) {
        toast.success(resp.message || "HELP/FAQ updated successfully");
        const nextHelp = helpChanged ? helpHtml : initialHelpHtml;
        const nextFaq = faqChanged ? faqHtml : initialFaqHtml;
        setInitialHelpHtml(nextHelp);
        setInitialFaqHtml(nextFaq);
      } else {
        toast.error(resp.message || "Update failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("Update failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div class="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
        <div class="h-screen flex-grow-1 overflow-y-lg-auto">
          <CommonHeader />

          <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
              <div class="card shadow border-0 mb-7">
                <div class="card-header">
                  <h5 class="mb-0">Help / FAQ Content</h5>
                </div>

                <div class="card-body">
                  {loading ? (
                    <div class="text-center">
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div class="row g-3">
                        <div class="col-12 col-md-6">
                          <label class="form-label mb-2">Help HTML</label>
                          <textarea
                            class="form-control"
                            rows="12"
                            value={helpHtml}
                            onChange={(e) => setHelpHtml(e.target.value)}
                            placeholder="<p>Help content...</p>"
                          />
                        </div>

                        <div class="col-12 col-md-6">
                          <label class="form-label mb-2">FAQ HTML</label>
                          <textarea
                            class="form-control"
                            rows="12"
                            value={faqHtml}
                            onChange={(e) => setFaqHtml(e.target.value)}
                            placeholder="<p>FAQ content...</p>"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div class="card-footer border-0 py-5">
                  <button
                    class="btn d-inline-flex btn-sm btn-primary mx-1"
                    onClick={handleUpdate}
                    disabled={loading || saving || !loaded}
                  >
                    <span class="pe-2">
                      <i class="bi bi-save"></i>
                    </span>
                    <span>{saving ? "Updating..." : "Update HELP/FAQ"}</span>
                  </button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default HelpFaqManagement;

